'use es6';

import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { registerMutation, registerQuery } from 'data-fetching-client';
const FAVORITES_DASHBOARDS_URL = 'dashboard/v2/favorite/dashboard';
const FAVORITES_REPORTS_URL = 'dashboard/v2/favorite/reports';
export const FAVORITE_DASHBOARDS_FIELD_NAME = 'favoriteDashboards';
export const FAVORITE_REPORTS_FIELD_NAME = 'favoriteReports';

// @returns {List()} A List of Maps with the shape { name, objectId, objectType, portalId, userId }
export const FETCH_FAVORITE_DASHBOARDS = registerQuery({
  fieldName: FAVORITE_DASHBOARDS_FIELD_NAME,
  fetcher() {
    return http.get(FAVORITES_DASHBOARDS_URL).then(response => fromJS(response));
  }
});

// @returns {List()} A List of Maps with the shape { name, objectId, objectType, portalId, userId }
export const FETCH_FAVORITE_REPORTS = registerQuery({
  fieldName: FAVORITE_REPORTS_FIELD_NAME,
  fetcher() {
    return http.get(FAVORITES_REPORTS_URL).then(response => fromJS(response));
  }
});

// @reportId {Number}
export const ADD_REPORT_TO_FAVORITES = registerMutation({
  fieldName: FAVORITE_REPORTS_FIELD_NAME,
  args: ['reportId'],
  fetcher({
    reportId
  }) {
    return http.post(FAVORITES_REPORTS_URL, {
      data: {
        objectId: reportId
      }
    });
  }
});

// @reportId {Number}
export const REMOVE_REPORT_FROM_FAVORITES = registerMutation({
  fieldName: FAVORITE_REPORTS_FIELD_NAME,
  args: ['reportId'],
  fetcher({
    reportId
  }) {
    return http.delete(`${FAVORITES_REPORTS_URL}/${reportId}`);
  }
});

// @dashboardId {Number}
export const ADD_DASHBOARD_TO_FAVORITES = registerMutation({
  fieldName: FAVORITE_DASHBOARDS_FIELD_NAME,
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return http.post(FAVORITES_DASHBOARDS_URL, {
      data: {
        objectId: dashboardId
      }
    });
  }
});

// @dashboardId {Number}
export const REMOVE_DASHBOARD_FROM_FAVORITES = registerMutation({
  fieldName: FAVORITE_DASHBOARDS_FIELD_NAME,
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return http.delete(`${FAVORITES_DASHBOARDS_URL}/${dashboardId}`);
  }
});